<template>
  <div class="about">
    <Menu v-show="false"></Menu>
    <MbrEdit2 :mbr="user" :regs="regs" :menu="true" v:show="!loading"></MbrEdit2>
  </div>
</template>

<script>
import Menu from '@/components/Menu.vue'
import MbrEdit2 from '@/components/MbrEdit2.vue'
export default {
  name: "MemberView",
  components: {
    Menu,
    MbrEdit2
  },
  mounted: function () {
    if (this.$usrStore.token == null) {
      if (localStorage.getItem('token') !== 'undefined') {
        if (localStorage.getItem('token').length > 4) {
          this.$initFromToken(localStorage.getItem('token'))
        }
      }
    }
    if(!this.$itmStore.titles){
      this.$loadTitles()
    }
    this.loadUser()
  },
  data: () => ({
    user: {},
    regs: [],
    loading: true
  }),
  methods: {
    loadRegs: function(dogId) {
      this.$http.post(this.$remote + '/api.trial/teamregs', {dognum: dogId, token: localStorage.getItem('token')})
          .then(response => {
            this.$usrStore.token = response.data.token
            this.regs = response.data
            console.log(this.regs)
          }).catch(reason => {
        alert('Could not refresh the TRIAL data from the server. Please log in again and retry. Server reported: ' + reason)
      })
    },

    loadUser: function () {
      if (!this.$isTokenCurrent()) {
        this.$logOut()
        this.$router.push('/')
        return
      } else {
        let theToken = localStorage.getItem('token')
        if (theToken == null) {
          alert('Token is null')
          this.$router.push('/')
        }
        this.error = this.jsdoc = null
        this.loading = true
        this.$initFromToken(localStorage.getItem('token'))
        //this.$loadAll()

        this.$http.post(this.$remote + '/api/mbr', {
          token: theToken,
          mbrId: this.$usrStore.id
        })
            .then(response => {
              this.user = response.data.mbr
              this.$usrStore.token = response.data.token
              localStorage.setItem('token', response.data.token)
              this.loading = false
              console.log('MemberView loadUser')
              console.log(this.user)
            })
            .catch(function (err) {
                  if (err.response.data) {
                    alert(err.response.data.msg)
                    this.$logOut()
                    this.$router.push('/')
                    //window.location.assign('/logout')
                  } else {
                    alert(err)
                  }
                }
            )
      }
    }
  }

}
</script>
